import { useState } from "react";
import { Routes, Route } from "react-router-dom";

// screens
import Dashboard from "../dashboard/Dashboard";
import ErrorBoundary from "../../components/error/AppErrorBoundary";
import TwoFactorAuthentication from "../authentication/TwoFactorAuthentication";
import ProtectedRoute from "./ProtectedRoute";
import ForgotPassword from "../authentication/ForgotPassword";
import Signin from "../authentication/Signin";
import Students from "../students/Students";
import SchoolStaff from "../staff/SchoolStaff";
import AddUpdateSession from "../session/AddUpdateSession";
import Terms from "../term/Terms";
import AddUpdateSchoolStaff from "../staff/AddUpdateSchoolStaff";
import Sessions from "../session/Sessions";
import SchoolClasses from "../classes/SchoolClasses";
import AddUpdateClasses from "../classes/AddUpdateClasses";
import Subjects from "../subjects/Subjects";
import AddUpdateSubject from "../subjects/AddUpdateSubjects";
import AddUpdateStudent from "../students/AddUpdateStudent";
import ClassProfile from "../classes/ClassProfile";
import AddSubjectsToClass from "../classes/AddSubjectsToClass";
import StudentsPerformance from "../classes/StudentsPerformance";
import StaffProfile from "../staff/StaffProfile";
import AssignSubjectToStaff from "../staff/AssignSubjectToStaff";
import AssignClassToStaff from "../staff/AssignClassToStaff";
import StudentsProfile from "../students/StudentsProfile";
import SetAssessment from "../assessment/SetAssessment";
import RecordAssessment from "../assessment/RecordAssessment";
import AcademicSettings from "../settings/AcademicSettings";
import PositionAssessment from "../assessment/PositionAssessment";
import SubjectsToAssess from "../assessment/SubjectsToAssess";
import ReportSheet from "../assessment/ReportSheet";
import ResultChecker from "../assessment/ResultCheck";
import ResetPassword from "../authentication/ResetPassword";
import NotFound from "../error_pages/NotFound";
import UnauthorizedPage from "../error_pages/UnauthorizedPage";
import AddUpdateClassCategories from "../classes/AddUpdateClassCategories";
import ClassCategories from "../classes/ClassCategories";
import Disciplines from "../disciplines/Disciplines";
import UpdateClassTeachers from "../settings/UpdateClassTeachers";
import AddUpdateDiscipline from "../disciplines/AddUpdateDiscipline";
import AttendanceDashboard from "../attendance/AttendanceDashboard";
import AttendanceCheckIn from "../attendance/AttendanceCheckIn";
import AttendanceScanner from "../attendance/AttendanceScanner";
import AttendanceManual from "../attendance/AttendanceManual";
import AttendanceHistory from "../attendance/AttendanceHistory";
import SettingsUpdatePassword from "../settings/UpdatePassword";
import AssessmentSettings from "../settings/AssessemntSettings";
import SchoolProfile from "../settings/SchoolProfile";
import GraduationYears from "../graduated_students/GraduationYears";
import Transcript from "../students/Transcript";
import RatingIndices from "../assessment/RatingIndices";
import AddUpdateRatingIndice from "../assessment/AddRatingIndices";
import Psychomotor from "../assessment/Psychomotor";
import AddUpdatePsychomotor from "../assessment/AddUpdatePsychomotor";
import AffectiveDomains from "../assessment/AffectiveDomains";
import AddUpdateAffectiveDomain from "../assessment/AddUpdateAffectiveDomain";
import DisplayReportSheet from "../assessment/DisplayReportSheet";
import TimeTableDashboard from "../timeTable/TimeTableDashboard";
import Settings from "../settings/Settings";
import UpdateClassScheduleInterval from "../settings/UpdateClassScheduleInterval";
import AddClassSchedule from "../timeTable/AddClassSchedule";
import AddSingleClassSchedule from "../timeTable/AddSingleClassSchedule";
import UpdateSingleClassSchedule from "../timeTable/UpdateSingleClassSchedule";
import UpdateProfile from "../settings/UpdateProfile";
import AddUpdateParents from "../parents/AddUpdateParents";
import Parents from "../parents/Parents";
import ParentProfile from "../parents/ParentProfile";
import AssignChildrenToParent from "../parents/AssignChildrenToParent";
import AddUpdateUserGroup from "../userGroups/AddUpdateUserGroup";
import UserGroups from "../userGroups/UserGroups";
import AddUpdateSubjectActivities from "../subjects/AddUpdateSubjectActivities";
import SubjectActivities from "../subjects/SubjectActivities";
import ClassBioData from "../classes/ClassBioData";
import AddUpdateActivitiesType from "../activities/AddUpdateActivitiesType";
import ActivitiesDashboard from "../activities/ActivitiesDashboard";
import ActivityTypes from "../activities/ActivityTypes";
import AddUpdateActivity from "../activities/AddUpdateActivity";
import BroadSheet from "../students/BraodSheet";
import LogUserOut from "../authentication/LogUserOut";
import ListActivities from "../activities/ListActivities";
import FeeDashboard from "../finance/FeeDashboard";
import AddUpdateFeeCategory from "../finance/AddUpdateFeeCategory";
import FeeCategories from "../finance/FeeCategories";
import AddUpdateFee from "../finance/AddUpdateFee";
import Fees from "../finance/Fees";
import AddUpdatePayment from "../payment/AddUpdatePayment";
import PaymentDashboard from "../payment/PaymentDashboard";
import PaymentInvoice from "../payment/PaymentInvoice";
import BankAccounts from "../payment/BankAccounts";
import AddUpdateBankAccount from "../payment/AddUpdateBankAccount";
import PaymentHistory from "../payment/PaymentHistory";
import PayFromWallet from "../subscription/PayFromWallet";
import Wallet from "../wallet/WalletDashboard";
import StudentReports from "../classes/Reports";
import DisplayAllClassResults from "../assessment/DisplayAllClassResults";
import StudentForm from "../classes/StudentForm";
import AssignStudentsToStream from "../classes/AssignStudentsToStream";

const Root = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="container">
      <Routes>
        {/* authentication. Non protected */}
        <Route
          path="/authentication/two-factor"
          element={<TwoFactorAuthentication />}
          errorElement={<ErrorBoundary />}
        />
        <Route path="/" element={<Signin />} errorElement={<ErrorBoundary />} />
        <Route
          element={<ForgotPassword />}
          errorElement={<ErrorBoundary />}
          path="/forgot-password"
        />
        <Route
          element={<ResetPassword />}
          errorElement={<ErrorBoundary />}
          path="/reset-password"
        />

        {/* protected route */}
        <Route element={<ProtectedRoute />} errorElement={<ErrorBoundary />}>
          <Route
            element={<LogUserOut />}
            errorElement={<ErrorBoundary />}
            path="/logout"
          />
          <Route
            element={
              <UpdateProfile
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            path="/update-profile"
          />
          <Route
            element={
              <Dashboard
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            path="/dashboard"
          />
          <Route
            path="/students/class/:classId?"
            element={
              <Students
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/students/class/:classId/:promotion"
            element={
              <Students
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/disciplines"
            element={
              <Disciplines
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/discipline/add"
            element={
              <AddUpdateDiscipline
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/discipline/:disciplineId/update"
            element={
              <AddUpdateDiscipline
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/staff/:staffId/subjects/assign"
            element={
              <AssignSubjectToStaff
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/attendance/dashboard"
            element={
              <AttendanceDashboard
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/rating-indices"
            element={
              <RatingIndices
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/rating-index/add"
            element={
              <AddUpdateRatingIndice
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/parents/add"
            element={
              <AddUpdateParents
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/parents/:parentId/update"
            element={
              <AddUpdateParents
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/parent/:parentId/profile"
            element={
              <ParentProfile
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/parent/:parentId/add-children"
            element={
              <AssignChildrenToParent
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/rating-index/:ratingId/update"
            element={
              <AddUpdateRatingIndice
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/psychomotor"
            element={
              <Psychomotor
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/psychomotor/add"
            element={
              <AddUpdatePsychomotor
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/psychomotor/:psychomotorId/update"
            element={
              <AddUpdatePsychomotor
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/affective-domains"
            element={
              <AffectiveDomains
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/affective-domain/add"
            element={
              <AddUpdateAffectiveDomain
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/affective-domain/:affectiveDomainId/update"
            element={
              <AddUpdateAffectiveDomain
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/student/:studentId/report-sheet/session/:sessionId/term/:termId/class/:classId"
            element={
              <DisplayReportSheet
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/student/report-sheet/session/:sessionId/term/:termId/class/:classId"
            element={
              <DisplayAllClassResults
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/attendance/type"
            element={
              <AttendanceCheckIn
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/user-group/add"
            element={
              <AddUpdateUserGroup
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/user-group/:userGroupId/update"
            element={
              <AddUpdateUserGroup
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/user-groups"
            element={
              <UserGroups
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/time-table/home"
            element={
              <TimeTableDashboard
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/time-table/add"
            element={
              <AddClassSchedule
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/attendance/history"
            element={
              <AttendanceHistory
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/attendance/scanner"
            element={
              <AttendanceScanner
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/attendance/manual"
            element={
              <AttendanceManual
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/settings/class/teachers"
            element={
              <UpdateClassTeachers
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/staff/:staffId/class/assign"
            element={
              <AssignClassToStaff
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/staff/:staffId/profile"
            element={
              <StaffProfile
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/student/:studentId/profile"
            element={
              <StudentsProfile
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/set"
            element={
              <SetAssessment
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/result-checker"
            element={
              <ResultChecker
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/report-sheet"
            element={
              <ReportSheet
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/student/:studentId/transcript"
            element={
              <Transcript
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/subjects"
            element={
              <SubjectsToAssess
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/position"
            element={
              <PositionAssessment
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/assessment/record"
            element={
              <RecordAssessment
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/settings/grade"
            element={
              <AcademicSettings
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/settings/home"
            element={
              <Settings
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/settings/class-schedule-intervals"
            element={
              <UpdateClassScheduleInterval
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/settings/update-password"
            element={
              <SettingsUpdatePassword
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/settings/profile"
            element={
              <SchoolProfile
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/graduation-years"
            element={
              <GraduationYears
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/graduation/class/:graduationClassId/:graduationClassTitle/year/:graduationYear"
            element={
              <Students
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/settings/assessment"
            element={
              <AssessmentSettings
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/parents"
            element={
              <Parents
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/class/:classId/subjects/add"
            element={
              <AddSubjectsToClass
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/students"
            element={
              <Students
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/class/:classId/students/performance"
            element={
              <StudentsPerformance
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/student/add"
            element={
              <AddUpdateStudent
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/student/:studentId/update"
            element={
              <AddUpdateStudent
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/staff"
            element={
              <SchoolStaff
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/staff/add"
            element={
              <AddUpdateSchoolStaff
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/staff/:staffId/update"
            element={
              <AddUpdateSchoolStaff
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/session/add"
            element={
              <AddUpdateSession
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/session/update/:sessionId"
            element={
              <AddUpdateSession
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/class/categories"
            element={
              <ClassCategories
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/class/categories/add"
            element={
              <AddUpdateClassCategories
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/class/category/:categoryId/update"
            element={
              <AddUpdateClassCategories
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/sessions"
            element={
              <Sessions
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/class-schedule/add-single"
            element={
              <AddSingleClassSchedule
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/class-schedule/update"
            element={
              <UpdateSingleClassSchedule
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/terms"
            element={
              <Terms sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/classes"
            element={
              <SchoolClasses
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/class/add"
            element={
              <AddUpdateClasses
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/class/:classId/update"
            element={
              <AddUpdateClasses
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/classes/:classId/profile"
            element={
              <ClassProfile
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/subjects"
            element={
              <Subjects
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/subject/add"
            element={
              <AddUpdateSubject
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/subject/:subjectId/update"
            element={
              <AddUpdateSubject
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/subject-activity/add"
            element={
              <AddUpdateSubjectActivities
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/subject-activities"
            element={
              <SubjectActivities
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/subject-activity/:subjectActivityId/update"
            element={
              <AddUpdateSubjectActivities
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/students/class/:classId/bio-data"
            element={
              <ClassBioData
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/activities/home"
            element={
              <ActivitiesDashboard
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/activity-type/add"
            element={
              <AddUpdateActivitiesType
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/activity-type/:activityTypeId/update"
            element={
              <AddUpdateActivitiesType
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path="/activity-types"
            element={
              <ActivityTypes
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/activity/add"}
            element={
              <AddUpdateActivity
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/activity/:activityId/update"}
            element={
              <AddUpdateActivity
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/class/:classId/broad-sheet"}
            element={
              <BroadSheet
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/list-activities"}
            element={
              <ListActivities
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/fees/home"}
            element={
              <FeeDashboard
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/fees/fee-category/add"}
            element={
              <AddUpdateFeeCategory
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/fees/fee-category/:feeCategoryId/update"}
            element={
              <AddUpdateFeeCategory
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/fees/fee-categories"}
            element={
              <FeeCategories
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/fees/add"}
            element={
              <AddUpdateFee
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/fees/list-fees"}
            element={
              <Fees sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/fee/:feeId/update"}
            element={
              <AddUpdateFee
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/finance/payment/add"}
            element={
              <AddUpdatePayment
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/finance/payment/update"}
            element={
              <AddUpdatePayment
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/finance/home"}
            element={
              <PaymentDashboard
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/finance/invoice/:invoiceId"}
            element={
              <PaymentInvoice
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/finance/bank-accounts"}
            element={
              <BankAccounts
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/finance/bank-account/add"}
            element={
              <AddUpdateBankAccount
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/finance/bank-account/:bankAccountId/update"}
            element={
              <AddUpdateBankAccount
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/finance/payment-history"}
            element={
              <PaymentHistory
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          {/* <Route
            path={"/wallet"}
            element={
              <Wallet sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
            }
            errorElement={<ErrorBoundary />}
          /> */}
          {/* <Route
            path={'/subscription'}
            element={
              <SubscriptionDashboard
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          /> */}
          {/* <Route
            path={"/pay-from-wallet"}
            element={
              <PayFromWallet
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          /> */}
          <Route
            path={"/students/class/:classId/reports"}
            element={
              <StudentReports
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/students/form"}
            element={
              <StudentForm
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
          <Route
            path={"/students/class/:classId/stream/:streamId/assign"}
            element={
              <AssignStudentsToStream
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            }
            errorElement={<ErrorBoundary />}
          />
        </Route>
        {/* authentication. Non protected */}
        <Route path="*" element={<NotFound />} />
        <Route path="/not-found" element={<NotFound />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
      </Routes>
    </div>
  );
};

export default Root;
